var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.57143L13.0327 5.26705C11.3783 6.21237 10.5512 6.68509 9.67517 6.8704C8.89983 7.03437 8.10017 7.03437 7.32483 6.8704C6.44887 6.68509 5.62169 6.21237 3.96733 5.26705L1 3.57143M3.66667 13H13.3333C14.2667 13 14.7335 13 15.09 12.8131C15.4036 12.6488 15.6586 12.3865 15.8183 12.064C16 11.6973 16 11.2172 16 10.2571V3.74286C16 2.78277 16 2.30272 15.8183 1.93602C15.6586 1.61345 15.4036 1.3512 15.09 1.18685C14.7335 1 14.2667 1 13.3333 1H3.66667C2.73325 1 2.26653 1 1.91002 1.18685C1.59641 1.3512 1.34144 1.61345 1.18166 1.93602C1 2.30272 1 2.78276 1 3.74286V10.2571C1 11.2172 1 11.6973 1.18166 12.064C1.34144 12.3865 1.59641 12.6488 1.91002 12.8131C2.26653 13 2.73324 13 3.66667 13Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMail);
export default __webpack_public_path__ + "static/media/ic_mail.c2e550c2bff8334220334a265287b659.svg";
export { ForwardRef as ReactComponent };